// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"939":"300c3848","966":"61e6d590"}[chunkId] + ".chunk.css";
};